import { render } from "./Bracket.vue?vue&type=template&id=37460d66&scoped=true"
import script from "./Bracket.vue?vue&type=script&lang=js"
export * from "./Bracket.vue?vue&type=script&lang=js"

import "./Bracket.vue?vue&type=style&index=0&id=37460d66&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37460d66"]])

export default __exports__